import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { BiRightArrowAlt, BiMap } from "react-icons/bi";
import { motion } from "framer-motion"; // Animation के लिए
// import "./Domestic.css";

// Images import
import ker from '../Ecomphotos/kerr.jpg';
import kas from '../Ecomphotos/kashmir.jpg';
import raj from '../Ecomphotos/rajasthan.jpg';
import hima from '../Ecomphotos/kash.jpg';

export default function Domestic() {
  const packages = [
    { id: 1, title: "Rajasthan Royal Tour", img: raj, link: "/Rajasthan", desc: "Experience the royal heritage of palaces and forts." },
    { id: 2, title: "Himachal Adventure", img: hima, link: "/Himachal", desc: "Snow-capped peaks and thrilling adventures await." },
    { id: 3, title: "Kashmir Paradise", img: kas, link: "/Kashmir", desc: "Explore the heaven on Earth with serene valleys." },
    { id: 4, title: "Kerala Backwaters", img: ker, link: "/Kerala", desc: "Unwind in the lush greenery and calm waters." },
  ];

  return (
    <section className="domestic-packages py-5">
      <div className="container">
        
        {/* Modern Header */}
        <div className="text-center mb-5">
          <motion.h5 
            initial={{ opacity: 0 }} 
            whileInView={{ opacity: 1 }} 
            className="subtitle"
          >
            Explore India
          </motion.h5>
          <h2 className="main-title">
            Our Best <span className="text-gradient">Domestic Packages</span>
          </h2>
          <p className="description-text mx-auto">
            From royal palaces to serene backwaters, <strong>Jawali Holidays</strong> plans the perfect getaway tailored to your dreams.
          </p>
        </div>

        {/* Packages Grid */}
        <div className="row g-4">
          {packages.map((pkg, index) => (
            <motion.div 
              className="col-12 col-md-6 col-lg-3" 
              key={pkg.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="travel-card shadow-sm">
                <div className="img-container">
                  <img src={pkg.img} alt={pkg.title} className="card-image" />
                  <div className="location-badge">
                    <BiMap /> India
                  </div>
                </div>

                <div className="card-details p-4">
                  <h5 className="fw-bold mb-2">{pkg.title}</h5>
                  <p className="text-muted small card-desc">{pkg.desc}</p>
                  
                  <Link to={pkg.link} className="view-btn">
                    View Itinerary <BiRightArrowAlt size={20} />
                  </Link>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}